(() => {
  if (window.productPhotoGalleryModal_initialised) return;
  window.productPhotoGalleryModal_initialised = true;

  window.addEventListener("load", function () {
    const containers = Array.from(document.querySelectorAll(".js-product__photo-gallery-btn")).map(btn => btn.parentElement.parentElement);

    containers.forEach(container => {
      const modalTrigger = container.querySelector(".js-product__photo-gallery-btn");
      const modal = container.querySelector(".js-product__photo-gallery-modal");
      const modalContent = modal.querySelector(".content");
      const modalBackBtn = modal.querySelector(".back-btn");

      const show = () => {
        document.body.style.overflow = 'hidden';
        modal.classList.remove("hide");
      }

      const hide = () => {
        document.body.style.overflow = '';
        modal.classList.add("hide");
      }

      modalTrigger.addEventListener("click", () => {
        let imgEls = container.querySelectorAll(".product__thumbs .product__thumb-item:not(.product__thumb-item-video) img");
        if (imgEls.length === 0) imgEls = container.querySelectorAll(".product-image-main img.photoswipe__image");

        const imagesHtml = [...imgEls]
          .map(el => el.getAttribute('data-original-src'))
          .map((src, i) => `<div class="img-wrapper js-photoswipe__zoom" data-index="${i + 1}">
          <img
            class="photoswipe__image"
            sizes="477px"
            src="${src}"
            data-photoswipe-src="${src}"
            data-photoswipe-width="1000"
            data-photoswipe-height="1000"
          />
        </div>`)
          .join("");
        modalContent.innerHTML = imagesHtml;
        show();
        new theme.Photoswipe(modalContent, "productImagesModal");
      });

      modalBackBtn.addEventListener("click", () => {
        hide();
      });
    });
  });
})();